import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Text,
  SimpleGrid,
  Box,
  Input,
  FormLabel,
  Select,
  InputGroup,
  InputLeftAddon,
  useDisclosure,
  Checkbox,
} from "@chakra-ui/react";
import { useState, useEffect } from "react";
import { IoMdClose } from "react-icons/io";
import axios from "axios";
import toast from "react-hot-toast";
import Cookie from "js-cookie";

const SubTableUpdateModal = ({
  isOpen,
  onClose,
  customerId,
  onOpen,
  subTableNo,
  setSubTableNo,
  subTable,
  setSubTable,
}) => {
  const token = Cookie.get("token");
  const handleEdit = async () => {
    try {
      const response = await axios.put(
        `https://api.rasoi.launchlysoftware.in/api/subTableUpdate/${customerId}/${subTableNo}`,
        {
          data: { subTable: !subTable },
        },
      );
      toast.success(response.data.message);
      setSubTable(null);
      setSubTableNo("");
      window.location.reload();
      onClose();
    } catch (error) {
      if (error.response && error.response.status === 404) {
        toast.error(error.response.data.message);
        // Redirect to login page or perform other actions
      } else {
        toast.error("An error occurred");
      }
    }
  };

  const handleClick = () => {
    onClose();
    setSubTableNo("");
  };
  return (
    <Modal
      width="full"
      size="md"
      isOpen={isOpen}
      onClose={onClose}
      onOpen={onOpen}
    >
      <ModalOverlay />
      <ModalContent bg="#f9f1e3">
        <ModalHeader
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Text>Update Sub Table - {subTableNo}</Text>
          <Button colorScheme="red" onClick={handleClick}>
            <IoMdClose />
          </Button>
        </ModalHeader>

        <ModalBody>
          <Box
            display="flex"
            flexDirection="row"
            justifyContent="center"
            alignItems="center"
            gap="2"
          >
            <Button colorScheme="green" onClick={() => handleEdit()}>
              Update
            </Button>
            <Button colorScheme="red" onClick={() => handleClick}>
              Close
            </Button>
          </Box>
        </ModalBody>

        <ModalFooter></ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default SubTableUpdateModal;
